import { useCallback, useContext } from "react";
import { GlobalContext } from "../GlobalContext";
import { isValidArray } from "../../Layout/Common/common";
import { categoryById } from "../../utils/categoryIndex";

export const useCategoryLink = () => {
  const { linkedCategoryData, categoryIndex } = useContext(GlobalContext);

  return useCallback(
    (categoryId, url) => {
      const fallback = url ?? categoryById(categoryIndex, categoryId)?.url;
      if (!categoryId || !isValidArray(linkedCategoryData)) return fallback;
      const linked = linkedCategoryData.find((item) => item.categoryId == categoryId);
      if (!linked?.linkedCategoryUrl) return fallback;
      return "/" + String(linked.linkedCategoryUrl).replace(/^\/|\/$/g, "") + "/";
    },
    [linkedCategoryData, categoryIndex],
  );
};
